/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  ADD_ASSET_MEDIAS_SUCCESS,
  ADD_ASSET_MEDIAS_FAILURE,
  GET_ASSET_MEDIAS_SUCCESS,
  GET_ASSET_MEDIAS_FAILURE,
  DELETE_ASSET_MEDIA_SUCCESS,
  DELETE_ASSET_MEDIA_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  files: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_ASSET_MEDIAS_SUCCESS:
      return {
        isAddMediasSuccess: true,
        files: Object.assign(state.files, action.payload.data),
      };
    case ADD_ASSET_MEDIAS_FAILURE:
      return {
        isAddMediasSuccess: false,
        error: action.errResp.message,
        files: state.files,
      };
    case GET_ASSET_MEDIAS_SUCCESS:
      return {
        isGetMediasSuccess: true,
        files: action.payload.data,
      };
    case GET_ASSET_MEDIAS_FAILURE:
      return {
        isGetMediasSuccess: false,
        error: action.errResp.message,
        files: state.files,
      };
    case DELETE_ASSET_MEDIA_SUCCESS:
      return {
        isDeleteMediaSuccess: true,
        files: action.payload.data,
      };

    case DELETE_ASSET_MEDIA_FAILURE:
      return {
        isDeleteMediaSuccess: false,
        error: action.errResp.message,
        files: state.files,
      };

    default:
      return state;
  }
}
